import { Select } from "antd";
import React from "react";

interface Props {
  className?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const MultiTeamRoleSelect = ({ value, onChange, className = "" }: Props) => {
  return (
    <Select
      className={`${className}`}
      mode="multiple"
      value={value}
      onChange={onChange}
      placeholder="Select User Team Role"
    >
      <Select.Option value="OWNER">Manager</Select.Option>
      <Select.Option value="NONE">Member</Select.Option>
    </Select>
  );
};

export default MultiTeamRoleSelect;
